import { useEffect, useState } from "react";

import './BrandBanners.scss'
import { HomeBrandBanner } from "../../../../types/HomeBrandBanner";
import { mediaUrl } from "../../../../helper/Api";
interface BrandBannersProps {
  banners: HomeBrandBanner[];
  onAdd: () => void;
  onRemove: (id: string) => void;
  onUpdate: (slider: HomeBrandBanner) => void;
  updateSlider: (homeSlider : HomeBrandBanner,image : File | null) => void;
}

export default function BrandBanners({ banners, onAdd, onRemove, onUpdate, updateSlider }: BrandBannersProps) {
  //effects
  const [bannerImages, setBannerImages] = useState<Record<string, File>>({});

  //actions
  const handleImageUpload = (banner: HomeBrandBanner) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
  
    input.onchange = (e) => {
      const files = (e.target as HTMLInputElement).files;
      if (files && files.length > 0) {
        const file = files[0];
          setBannerImages(prev => ({ ...prev, [banner.id]: file }));
      }
    };
  
    input.click();
  };

  const save = (banner : HomeBrandBanner) => {
    updateSlider(banner,bannerImages[banner.id])
  }

  //Effects
  useEffect(() => {
    //avoid memory leaks
    return () => {
      Object.values(bannerImages).forEach(file => URL.revokeObjectURL(URL.createObjectURL(file)));
    };
  }, []);

  return (
    <div className="slider-wrap">
      <div className="slider-actions">
        <button className="add-btn" onClick={onAdd}>Add Brand Banner</button>
      </div>
      
      <div className="sliders-grid">
        {banners?.map((banner) =>{ 
           const bannerFile = bannerImages[banner?.id];
           const bannerPreview = bannerFile ? URL.createObjectURL(bannerFile) : banner?.image;
          return (
          <div key={banner?.id} className="slider-card">
            <div className="sliderActions">
                <button 
                className="save-btn"
                onClick={() => save(banner)}
              >
                Save
              </button>
              <input
                type="number"
                value={banner?.index || 0}
                onChange={(e) => onUpdate({...banner, index: Number(e.target.value)})}
                placeholder="Enter destination URL"
                className="index-input"
              />
              <button 
                className="remove-btn"
                onClick={() => onRemove(banner.id)}
              >
                ×
              </button>
            </div>
            {/* Image */}
            <div 
              className="image-upload desktop"
              onClick={() => handleImageUpload(banner)}
            >
              {bannerPreview ? (
                <>
                  <img src={mediaUrl(bannerPreview)} alt="Banner image" />
                  <span className="hover-text">Change banner image</span>
                </>
              ) : (
                <span>Upload banner image</span>
              )}
            </div>
            <input
              type="text"
              value={banner?.title || ''}
              onChange={(e) => onUpdate({...banner, title: e.target.value})}
              placeholder="Enter Brand Title"
              className="url-input"
            />
            
          </div>
        )})}
      </div>
    </div>
  );
}